import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled, { css } from 'styled-components'
import ArrowDownSvg from 'assets/svgr-icons/Arrow_Down.svg'

const buttonOutlineStyles = css`
  &::before {
    content: ' ';
    position: absolute;
    z-index: -1;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 1px solid ${COLORS.primaryTint};
    border-radius: ${RADII.field};
  }
`

export const ImageStylesButton = styled.div<{
  $isToggled: boolean
  $disabled?: boolean
}>`
  position: relative;
  width: 100%;
  height: 40px;
  padding: 6px 12px;

  border-radius: ${RADII.field};
  border: 1px solid ${COLORS.borderColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  transition: all 0.2s ease;

  ${({ $isToggled, $disabled }) =>
    $isToggled
      ? css`
          border-color: ${COLORS.primaryDark};
          ${buttonOutlineStyles}
        `
      : !$disabled
        ? css`
            &:hover {
              border-color: ${COLORS.secondarySemiLight};
            }
          `
        : css`
            cursor: default;
          `}
`

export const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SelectedStyleImg = styled.div`
  width: 28px;
  height: 28px;

  overflow: hidden;
  border-radius: ${RADII.item};

  display: flex;
  align-items: center;
  justify-content: center;
`

export const Arrow = styled(ArrowDownSvg)`
  transform: rotate(-90deg);
  fill: ${COLORS.secondarySemiDark};
`
export const StyleImage = styled.img<{
  $isLoading?: boolean
}>`
  object-fit: cover;
  /* max-width: 100%; for real data as it must be square */
  /* max-height: 100%; */
  height: 100%; // todoA dlete after real data just let max-width: 100%; max-height: 100%;

  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
`
